import type { PblSignatureUpload, PblUploadedFile, PblUploadPurpose } from '@/types/pbl';

export const getUploadedPblFileId = (uploads: PblUploadedFile | PblSignatureUpload[] | PblSignatureUpload) => {
  const upload = Array.isArray(uploads) ? uploads[0] : uploads;

  if (!upload) return undefined;
  if ('file_id' in upload) return upload.file_id;
  if ('file' in upload) return upload.file?.id;
  return upload.id;
};

export const createPblUploadFormData = (file: File, purpose: PblUploadPurpose) => {
  const formData = new FormData();
  formData.append('purpose', purpose);
  formData.append('file', file);
  return formData;
};

export const createLocalDocumentUrl = (file: File) => {
  if (typeof URL === 'undefined' || typeof URL.createObjectURL !== 'function') return undefined;
  return URL.createObjectURL(file);
};
